var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummaryTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Banking & Finance/bars-alt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 7C18.3431 7 17 8.34315 17 10V18C17 19.6569 18.3431 21 20 21C21.6569 21 23 19.6569 23 18V10C23 8.34315 21.6569 7 20 7ZM4 11C2.34315 11 1 12.3431 1 14V18C1 19.6569 2.34315 21 4 21C5.65685 21 7 19.6569 7 18V14C7 12.3431 5.65685 11 4 11Z",
    fill: "#8278F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3C10.3431 3 9 4.34315 9 6V18C9 19.6569 10.3431 21 12 21C13.6569 21 15 19.6569 15 18V6C15 4.34315 13.6569 3 12 3Z",
    fill: "#E5E5E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryTab);
export default __webpack_public_path__ + "static/media/summary_tab.4979abda7a21b33ce570481408a45e78.svg";
export { ForwardRef as ReactComponent };